import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { ghgCategoryField } from './common/sharedFields';
import {
  ceeBuildingAreaQuantityField,
  ceeBuildingQuantityField,
  buildingKindField,
  buildingHeatSourceField,
} from './common/buildingCommonFields';
import { locationCountryField } from './common/locationFields';
import { genericUnitField } from './common/sharedFields';
import { percentRenewableField } from './common/electricityFields';

export const ceeBuildingMetadata = {
  displayName: msg({
    message: 'CEE Building',
    context: 'Activity data schema name for CEE Building',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    building_area: ceeBuildingAreaQuantityField,
    building_area_unit: {
      displayName: msg({
        message: 'Raw area unit',
        context: 'The unit of the raw area.',
      }),
    },
    building_heat_source: buildingHeatSourceField,
    building_kind: buildingKindField,
    building_quantity: ceeBuildingQuantityField,
    country: locationCountryField,
    percent_renewable: percentRenewableField,
    quantity: ceeBuildingQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
